import { render, staticRenderFns } from "./TabVip.vue?vue&type=template&id=96566f8e&scoped=true&"
import script from "./TabVip.vue?vue&type=script&lang=js&"
export * from "./TabVip.vue?vue&type=script&lang=js&"
import style0 from "./TabVip.vue?vue&type=style&index=0&id=96566f8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96566f8e",
  null
  
)

export default component.exports